export const apiPaths = {
  auth: {
    login: "/v1/auth/login",
  },
  gbif: {
    speciesMatch: "https://api.gbif.org/v1/species/match?name=",
  },
  releases: {
    create: "/v1/releases",
    getById: (id: string) => `/v1/releases/${id}`,
    list: "/v1/releases",
    getGeoJson: "/v1/releases/geojson",
    update: (id: string) => `/v1/releases/${id}`,
    export: "/v1/releases/export",
  },
  individuals: {
    create: "/v1/individuals",
    update: (id: string) => `/v1/individuals/${id}`,
    createAttachments: (id: string) => `/v1/individuals/${id}/attachments`,
    getAttachments: (id: string) => `/v1/individuals/${id}/attachments`,
    list: "/v1/individuals",
    getGeoJson: "/v1/individuals/geojson",
    getById: (id: string) => `/v1/individuals/${id}`,
    statistics: "/v1/individuals/statistics",
    export: "/v1/individuals/export",
    additionalData: {
      list: (id: string) => `/v1/individuals/${id}/additional-data`,
      export: `/v1/individuals/additional-data/export`,
      create: (id: string) => `/v1/individuals/${id}/additional-data`,
      createAttachments: ({
        individualId,
        additionalDataId,
      }: {
        individualId: string;
        additionalDataId: string;
      }) =>
        `/v1/individuals/${individualId}/additional-data/${additionalDataId}/attachments`,
    },
    logs: {
      list: (individualId: string) => `/v1/individuals/${individualId}/logs`,
      getGeoJson: (individualId: string) =>
        `/v1/individuals/${individualId}/logs/geojson`,
    },
  },
  registers: {
    create: "/v1/registers",
    list: "/v1/registers",
    update: (id: string) => `/v1/registers/${id}`,
    createAttachments: (id: string) => `/v1/registers/${id}/attachments`,
    getAttachments: (id: string) => `/v1/registers/${id}/attachments`,
    getById: (id: string) => `/v1/registers/${id}`,
    getGeoJson: "/v1/registers/geojson",
    export: "/v1/registers/export",
  },
  samples: {
    create: "/v1/samples",
    list: "/v1/samples",
    update: (id: string) => `/v1/samples/${id}`,
    createAttachments: (id: string) => `/v1/samples/${id}/attachments`,
    getAttachments: (id: string) => `/v1/samples/${id}/attachments`,
    getById: (id: string) => `/v1/samples/${id}`,
    getGeoJson: "/v1/samples/geojson",
    export: "/v1/samples/export",
  },
  locations: {
    list: "/v1/locations",
    create: "/v1/locations",
    getById: (id: string) => `/v1/locations/${id}`,
    export: "/v1/locations/export",
  },
  visits: {
    list: "/v1/visits",
    create: "/v1/visits",
    update: (id: string) => `/v1/visits/${id}`,
    createAttachments: (id: string) => `/v1/visits/${id}/attachments`,
    getById: (id: string) => `/v1/visits/${id}`,
    export: "/v1/visits/export",
  },
  devices: {
    collars: {
      list: "/v1/devices/collars",
      create: "/v1/devices/collars",
      getGeoJson: "/v1/devices/collars/geojson",
      getById: (id: string) => `/v1/devices/collars/${id}`,
      update: (id: string) => `/v1/devices/collars/${id}`,
      updateIndividual: (id: string) =>
        `/v1/devices/collars/${id}/update-individual`,
      export: "/v1/devices/collars/export",
      logs: {
        list: (collarId: string) => `/v1/devices/collars/${collarId}/logs`,
        getGeoJson: (collarId: string) =>
          `/v1/devices/collars/${collarId}/logs/geojson`,
      },
    },
    cameraTraps: {
      list: "/v1/devices/camera-traps",
      create: "/v1/devices/camera-traps",
      getGeoJson: "/v1/devices/camera-traps/geojson",
      getById: (id: string) => `/v1/devices/camera-traps/${id}`,
      update: (id: string) => `/v1/devices/camera-traps/${id}`,
      createAttachments: (id: string) =>
        `/v1/devices/camera-traps/${id}/attachments`,
      getAttachments: (id: string) =>
        `/v1/devices/camera-traps/${id}/attachments`,
      export: "/v1/devices/camera-traps/export",
    },
  },
  users: {
    list: "/v1/users",
    create: "/v1/users",
    update: (id: string) => `/v1/users/${id}`,
    delete: (id: string) => `/v1/users/${id}`,
    getById: (id: string) => `/v1/users/${id}`,
    updateProfilePicture: (id: string) => `/v1/users/${id}/profile-picture`,
  },
  taxonomicGroups: {
    list: "/v1/taxonomic-groups",
    create: "/v1/taxonomic-groups",
    export: "/v1/taxonomic-groups/export",
    update: (id: string) => `/v1/taxonomic-groups/${id}`,
    getById: (id: string) => `/v1/taxonomic-groups/${id}`,
  },
  notifications: {
    list: "/v1/system-notifications",
  },
} as const;
